import { Button } from '@mui/base';
import { styled } from '@mui/material/styles';
import {
    ButtonProps as MuiButtonProps,
  } from "@mui/material";
import { Icon } from "../../icons";

export const CustomNumberSelectorContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '1px',
    alignSelf: 'stretch',
    width: 'fit-content',
    maxWidth: '24rem',
}));

export const CustomNumberButtonContainer = styled('div')(({ theme }) => ({
    '&:first-of-type button': {
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
    },
    '&.is-all-available&:last-child button': {
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
    }
}));

export const CustomLockedNumberButtonContainer = styled('div')(({ theme }) => ({
    position: 'relative',
    '&:last-child button': {
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
    },
    '&.is-all-locked&:first-of-type button': {
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
    }
}));

export const CustomIcon = styled(Icon)(({ theme }) => ({
    position: 'absolute',
    bottom: '4px',
    right: '4px',
    cursor: "not-allowed",
    pointerEvents: "auto",
    color: theme.colors["neutral.200"],
    width: "20px",
    height: "20px"
}));

export const CustomNumberButton = styled(Button)<MuiButtonProps>(({ theme }) => ({
    backgroundColor: theme.colors["neutral.800"],
    borderColor: theme.colors["neutral.800"],
    borderWidth: '2px',
    color: theme.colors["neutral.50"],
    display: 'flex',
    padding: '16px 24px',
    justifyContent: 'center',
    borderStyle: 'solid',
    alignItems: 'center',
    gap: theme.space._200,
    flex: '1 0 0',
    cursor: "pointer",
    '&:hover': {
        borderColor: theme.colors['lime.400'],
        color: theme.colors['lime.400'],
    },
    "&.is-selected": {
        borderColor: theme.colors['lime.400'],
        color: theme.colors['lime.400'],
    },
    textAlign: 'center',
    fontFamily: theme.fonts.default,
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.medium,
    lineHeight: theme.lineHeights.tall, 
    boxSizing: "content-box",
    width: '10px',
    height: '20px',

    "@media (max-width: 600px)": {
        width: '5px',
    },
}));

export const CustomLockedNumberButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.colors["neutral.900"],
    borderColor: theme.colors["neutral.900"],
    borderWidth: '2px',
    borderStyle: 'solid',
    color: theme.colors["neutral.700"],
    display: 'flex',
    padding: '16px 24px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.space._200,
    flex: '1 0 0',
    cursor: "not-allowed",
    pointerEvents: "auto",
    textAlign: 'center',
    fontFamily: theme.fonts.default,
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.medium,
    lineHeight: theme.lineHeights.tall, 
    boxSizing: "content-box",
    width: '10px',
    height: '20px',

    "@media (max-width: 600px)": {
        width: '5px',
    },
}));
